import AccessingRolontis from "@components/accessing-rolvedon";
import PortalServices from "@components/portal-services";
import * as React from 'react';
export default {
  AccessingRolontis,
  PortalServices,
  React
};